import { PureComponent } from 'react';
import { connect } from 'react-redux';

import SocialShareQuery from 'Query/SocialShare.query';
import { fetchQuery } from 'Util/Request';

import SocialShare from './SocialShare.component';

/** @namespace Pwa/Component/SocialShare/Container/mapStateToProps */
export const mapStateToProps = (state) => ({
    product: state.ProductReducer.product,
});

/** @namespace Pwa/Component/SocialShare/Container/mapDispatchToProps */
export const mapDispatchToProps = () => ({});

/** @namespace Pwa/Component/SocialShare/Container */
export class SocialShareContainer extends PureComponent {
    state = {
        isEnabled: null,
        isFacebookEnabled: null,
        isTwitterEnabled: null,
        isMessengerEnabled: null,
        isPinterestEnabled: null,
        isLlinkedinEnabled: null,
        isLTumblrEnabled: null,
    };

    componentDidMount() {
        this.getSocialShareConfig();
    }

    containerProps() {
        const { product } = this.props;

        return {
            product,
            ...this.state,
        };
    }

    getSocialShareConfig() {
        fetchQuery(SocialShareQuery.getSocialShareQuery()).then(
            /** @namespace Pwa/Component/SocialShare/Container/SocialShareContainer/getSocialShareConfig/fetchQuery/then */
            ({
                storeConfig: {
                    mpss_enabled,
                    mpss_fb_enabled,
                    mpss_twitter_enabled,
                    mpss_messenger_enabled,
                    mpss_pinterest_enabled,
                    mpss_linkedin_enabled,
                    mpss_tumblr_enabled,
                },
            }) => {
                this.setState({
                    isEnabled: mpss_enabled,
                    isFacebookEnabled: mpss_fb_enabled,
                    isTwitterEnabled: mpss_twitter_enabled,
                    isMessengerEnabled: mpss_messenger_enabled,
                    isPinterestEnabled: mpss_pinterest_enabled,
                    isLlinkedinEnabled: mpss_linkedin_enabled,
                    isLTumblrEnabled: mpss_tumblr_enabled,
                });
            }
        );
    }

    render() {
        return <SocialShare {...this.containerProps()} />;
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(SocialShareContainer);
